/* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createLocalizationProviderValidator } from "../localizationProviders/SWBaseLocalizationProvider";
/** @internal */ export const rootLocalizationProviderVersions = {};
/** @internal */ export const rootLocalizationProviderMigrations = defineMigrations({});
/** @public */ export function isLocalizationProvider(record) {
    if (!record) return false;
    return record.typeName === "localization_provider";
}
/** @public */ export function isLocalizationProviderId(id) {
    if (!id) return false;
    return id.startsWith("localization_provider:");
}
/** @public */ export function createLocalizationProviderId({ type, projectIdentifier, organizationId }) {
    return `localization_provider:${[
        type,
        organizationId,
        projectIdentifier
    ].join(":")}`;
}
/** @public */ export function parseLocalizationProviderId(id) {
    if (!id) return undefined;
    if (!id.startsWith("localization_provider:")) return undefined;
    // Split into many pieces
    const parts = id.replace("localization_provider:", "").split(":");
    const type = parts.shift();
    const organizationId = parseInt(parts.shift() || "");
    const projectIdentifier = parts.join(":");
    if (isNaN(organizationId)) return undefined;
    return {
        type: type,
        organizationId,
        projectIdentifier: projectIdentifier
    };
}
/** @internal */ export function createLocalizationProviderRecordType(localization_providers) {
    return createRecordType("localization_provider", {
        migrations: defineMigrations({
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(localization_providers, (_, v)=>v.migrations ?? defineMigrations({}))
        }),
        scope: "presence",
        validator: T.model("localization_provider", T.union("type", mapObjectMapValues(localization_providers, (type, { props, meta })=>createLocalizationProviderValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {},
            internalLocalizationProviderId: 0,
            visibilitySince: 0
        }));
}
